angular.module('impactx.controlstructure').controller('CTRLCCtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    CTRLCCtrl
]);

function CTRLCCtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/ctrlc/view";
    $scope.endPointSave = "/control/ctrlc/save";
    $scope.endPointDelete = "/control/ctrlc/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.ctrlc.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.ctrlc.readOnly && !$scope.data.ctrlc.deprecated;
    }
}